module.exports = __webpack_public_path__ + "media/img/payment-methods/visa-62269ab647ea9d937245f3caa0e673c1.svg";